import { RowItemType, Section, UIElementType } from '../../models';
import { SelectorIdentifier } from '../../models';
import { TritonSectionIds } from './base-config-models';
import { TritonLocationCardState } from './models';
import { field } from '../../core/field-schema';
import { enableField, disableField } from '../../actions';
import { AdvancedFieldId, CheckInHourOption, DEFAULT_CHECK_IN_TEXT_RECIPIENT_END_HOUR } from '../common.models';
import { getEmailRecipientValidators, getSmsRecipientValidators } from '../advanced-validators';

export const advanced = (state: TritonLocationCardState): Section => {
    const config = state.monitorConfiguration;

    return {
        info: {
            id: TritonSectionIds.Advanced,
            title: 'ADD_EDIT.ADD_ADVANCED',
            displayTitle: true,
            expandable: true,
            expanded: false,
        },
        rows: [
            {
                info: {
                    id: 'check-in-title-row',
                    panelClass: 'full-width',
                },
                items: [
                    {
                        id: 'check-in-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'checkInTitle',
                        label: 'LOCATION_CARD.CHECK_IN',
                        panelClass: 'font-600 section-subtitle subtitle-text font-600',
                    },
                ],
            },
            {
                info: {
                    id: 'check-in-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.toggle(AdvancedFieldId.CheckInEnable, 'checkinenable', {
                        label: 'LOCATION_CARD.MONITOR_CHECK_IN',
                        panelClass: 'each-Item item-flex-center',
                        value: config?.checkinenable ?? false,
                        events: {
                            onChange: (value) => [
                                value
                                    ? enableField({ fieldId: AdvancedFieldId.CheckInHour })
                                    : disableField({ fieldId: AdvancedFieldId.CheckInHour }),
                            ],
                        },
                    }),
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInHour, 'checkinhour', {
                        placeholder: 'LOCATION_CARD.CHECK_IN_HOUR',
                        value: config?.checkinhour ?? 0,
                        disabled: !config?.checkinenable,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'each-Item',
                    }),
                ],
            },
            {
                info: {
                    id: 'text-message-title-row',
                    panelClass: 'full-width',
                },
                items: [
                    {
                        id: 'text-message-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'textMessageTitle',
                        label: 'LOCATION_CARD.TEXT_MESSAGE',
                        panelClass: 'font-600 section-subtitle subtitle-text font-600',
                    },
                ],
            },
            {
                info: {
                    id: 'text-message-info-title-row',
                    panelClass: 'full-width',
                },
                items: [
                    {
                        id: 'text-message-info-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'textMessageInfoTitle',
                        label: 'LOCATION_CARD.TEXT_MESSAGE_INFO',
                        panelClass: 'font-400 section-subtitle subtitle-text font-400',
                    },
                ],
            },
            {
                info: {
                    id: 'recipient-1-title-row',
                     panelClass: 'custom-50p recipient-block-tight',
                },
                items: [
                    {
                        id: 'recipient-1-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'recipient1Title',
                        label: 'LOCATION_CARD.RECIPIENT_1',
                        textClass: 'input-text',
                        panelClass: 'custom-33p',
                    },
                    field.text(AdvancedFieldId.CheckInTextRecipient1, 'recipient1', {
                        value: config?.smsrecipients && config.smsrecipients[0] ? config.smsrecipients[0].recipient : null,
                        panelClass: 'custom-33p',
                        validators: getSmsRecipientValidators(),
                        allowPhoneCharacters: true,
                        events: {

                        },
                    }),
                    {
                        id: 'start-hour-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'startHourTitle',
                        label: 'LOCATION_CARD.START_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec1StartHour, 'startHour', {
                        value: config?.smsrecipients && config.smsrecipients[0] ? config.smsrecipients[0].startHour : 0,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                    {
                        id: 'end-hour-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'endHourTitle',
                        label: 'LOCATION_CARD.END_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec1EndHour, 'EndHour', {
                        value: config?.smsrecipients && config.smsrecipients[0] ? config.smsrecipients[0].endHour : DEFAULT_CHECK_IN_TEXT_RECIPIENT_END_HOUR,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                ],
            },
            {
                info: {
                    id: 'recipient-2-title-row',
                     panelClass: 'custom-50p recipient-block-tight',
                },
                items: [
                    {
                        id: 'recipient-2-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'recipient2Title',
                        label: 'LOCATION_CARD.RECIPIENT_2',
                        textClass: 'input-text',
                        panelClass: 'custom-33p',
                    },
                    field.text(AdvancedFieldId.CheckInTextRecipient2, 'recipient2', {
                        value: config?.smsrecipients && config.smsrecipients[1] ? config.smsrecipients[1].recipient : null,
                        panelClass: 'custom-33p',
                        validators: getSmsRecipientValidators(),
                        allowPhoneCharacters: true,
                        events: {

                        },
                    }),
                    {
                        id: 'start-hour-2-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'startHour2Title',
                        label: 'LOCATION_CARD.START_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec2StartHour, 'startHour', {
                        value:  config?.smsrecipients && config?.smsrecipients[1] ? config.smsrecipients[1].startHour : 0,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                    {
                        id: 'end-hour-2-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'endHour2Title',
                        label: 'LOCATION_CARD.END_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec2EndHour, 'EndHour', {
                        value: config?.smsrecipients && config?.smsrecipients[1] ? config.smsrecipients[1].endHour : DEFAULT_CHECK_IN_TEXT_RECIPIENT_END_HOUR,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                ],
            },
            {
                info: {
                    id: 'recipient-3-title-row',
                     panelClass: 'custom-50p recipient-block-tight',
                },
                items: [
                    {
                        id: 'recipient-3-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'recipient1Title',
                        label: 'LOCATION_CARD.RECIPIENT_3',
                        textClass: 'input-text',
                        panelClass: 'custom-33p',
                    },
                    field.text(AdvancedFieldId.CheckInTextRecipient3, 'recipient3', {
                        value: config?.smsrecipients && config.smsrecipients[2] ? config.smsrecipients[2].recipient : null,
                        panelClass: 'custom-33p',
                        validators: getSmsRecipientValidators(),
                        allowPhoneCharacters: true,
                        events: {

                        },
                    }),
                    {
                        id: 'start-hour-3-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'startHour3Title',
                        label: 'LOCATION_CARD.START_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec3StartHour, 'startHour', {
                        value: config?.smsrecipients && config?.smsrecipients[2] ? config.smsrecipients[2].startHour : 0,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                    {
                        id: 'end-hour-3-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'endHour3Title',
                        label: 'LOCATION_CARD.END_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec3EndHour, 'EndHour', {
                        value: config?.smsrecipients && config?.smsrecipients[2] ? config.smsrecipients[2].endHour : DEFAULT_CHECK_IN_TEXT_RECIPIENT_END_HOUR,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                ],
            },
            {
                info: {
                    id: 'recipient-4-title-row',
                     panelClass: 'custom-50p recipient-block-tight',
                },
                items: [
                    {
                        id: 'recipient-4-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'recipient4Title',
                        label: 'LOCATION_CARD.RECIPIENT_4',
                        textClass: 'input-text',
                        panelClass: 'custom-33p',
                    },
                    field.text(AdvancedFieldId.CheckInTextRecipient4, 'recipient4', {
                        value: config?.smsrecipients && config.smsrecipients[3] ? config.smsrecipients[3].recipient : null,
                        panelClass: 'custom-33p',
                        validators: getSmsRecipientValidators(),
                        allowPhoneCharacters: true,
                        events: {

                        },
                    }),
                    {
                        id: 'start-hour-4-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'startHour4Title',
                        label: 'LOCATION_CARD.START_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec4StartHour, 'startHour', {
                        value: config?.smsrecipients && config?.smsrecipients[3] ? config.smsrecipients[3].startHour : 0,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                    {
                        id: 'end-hour-4-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'endHour4Title',
                        label: 'LOCATION_CARD.END_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec4EndHour, 'EndHour', {
                        value: config?.smsrecipients && config?.smsrecipients[3] ? config.smsrecipients[3].endHour :DEFAULT_CHECK_IN_TEXT_RECIPIENT_END_HOUR,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                ],
            },
            {
                info: {
                    id: 'recipient-5-title-row',
                     panelClass: 'custom-50p',
                },
                items: [
                    {
                        id: 'recipient-5-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'recipient5Title',
                        label: 'LOCATION_CARD.RECIPIENT_5',
                        textClass: 'input-text',
                        panelClass: 'custom-33p',
                    },
                    field.text(AdvancedFieldId.CheckInTextRecipient5, 'recipient5', {
                        value: config?.smsrecipients && config.smsrecipients[4] ? config.smsrecipients[4].recipient : null,
                        panelClass: 'custom-33p',
                        validators: getSmsRecipientValidators(),
                        allowPhoneCharacters: true,
                        events: {

                        },
                    }),
                    {
                        id: 'start-hour-5-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'startHour5Title',
                        label: 'LOCATION_CARD.START_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec5StartHour, 'startHour', {
                        value: config?.smsrecipients && config?.smsrecipients[4] ? config.smsrecipients[4].startHour : 0,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                    {
                        id: 'end-hour-5-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'endHour5Title',
                        label: 'LOCATION_CARD.END_HOUR',
                        textClass: 'input-text',
                        panelClass: 'custom-33p padding-left-8',
                    },
                    field.select<CheckInHourOption, number>(AdvancedFieldId.CheckInTextRec5EndHour, 'EndHour', {
                        value: config?.smsrecipients && config?.smsrecipients[4] ? config.smsrecipients[4].endHour : DEFAULT_CHECK_IN_TEXT_RECIPIENT_END_HOUR,
                        optionsSelector: SelectorIdentifier.CheckInHourOptions,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-33p width-15',
                    }),
                ],
            },
            {
                info: {
                    id: 'email-title-row',
                    panelClass: 'full-width',
                },
                items: [
                    {
                        id: 'email-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'textMessageTitle',
                        label: 'LOCATION_CARD.EMAIL',
                        panelClass: 'font-600 section-subtitle subtitle-text font-600',
                    },
                ],
            },
            {
                info: {
                    id: 'email-info-title-row',
                    panelClass: 'full-width',
                },
                items: [
                    {
                        id: 'email-info-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'emailInfoTitle',
                        label: 'LOCATION_CARD.EMAIL_INFO',
                        panelClass: 'font-400 section-subtitle subtitle-text font-400',
                    },
                ],
            },
            {
                info: {
                    id: 'email-title-row',
                     panelClass: 'custom-50p  recipient-block-tight',
                },
                items: [
                    {
                        id: 'email-recipient-1-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'emailRecipient1Title',
                        label: 'LOCATION_CARD.RECIPIENT_1',
                        textClass: 'input-text',
                        panelClass: 'custom-33p width-30',
                    },
                    field.text(AdvancedFieldId.CheckInEmailRecipient1, 'recipient1', {
                        value: config?.emailrecipients && config.emailrecipients[0] ? config.emailrecipients[0].recipient : null,
                        panelClass: 'custom-33p padding-right-50',
                        validators: getEmailRecipientValidators(),
                        allowEmailCharacters: true,
                        events: {

                        },
                    })
                ],
            },
            {
                info: {
                    id: 'email2-title-row',
                     panelClass: 'custom-50p  recipient-block-tight',
                },
                items: [
                    {
                        id: 'email-recipient-2-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'emailRecipient2Title',
                        label: 'LOCATION_CARD.RECIPIENT_2',
                        textClass: 'input-text',
                        panelClass: 'custom-33p width-30',
                    },
                    field.text(AdvancedFieldId.CheckInEmailRecipient2, 'recipient2', {
                        value: config?.emailrecipients && config.emailrecipients[1] ? config.emailrecipients[1].recipient : null,
                        panelClass: 'custom-33p padding-right-50',
                        validators: getEmailRecipientValidators(),
                        allowEmailCharacters: true,
                        events: {

                        },
                    })
                ],
            },
            {
                info: {
                    id: 'email3-title-row',
                     panelClass: 'custom-50p  recipient-block-tight',
                },
                items: [
                    {
                        id: 'email-recipient-3-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'emailRecipient3Title',
                        label: 'LOCATION_CARD.RECIPIENT_3',
                        textClass: 'input-text',
                        panelClass: 'custom-33p width-30',
                    },
                    field.text(AdvancedFieldId.CheckInEmailRecipient3, 'recipient3', {
                        value: config?.emailrecipients && config.emailrecipients[2] ? config.emailrecipients[2].recipient : null,
                        panelClass: 'custom-33p padding-right-50',
                        validators: getEmailRecipientValidators(),
                        allowEmailCharacters: true,
                        events: {

                        },
                    })
                ],
            },
            {
                info: {
                    id: 'email4-title-row',
                     panelClass: 'custom-50p  recipient-block-tight',
                },
                items: [
                    {
                        id: 'email-recipient-4-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'emailRecipient4Title',
                        label: 'LOCATION_CARD.RECIPIENT_4',
                        textClass: 'input-text',
                        panelClass: 'custom-33p width-30',
                    },
                    field.text(AdvancedFieldId.CheckInEmailRecipient4, 'recipient4', {
                        value: config?.emailrecipients && config.emailrecipients[3] ? config.emailrecipients[3].recipient : null,
                        panelClass: 'custom-33p padding-right-50',
                        validators: getEmailRecipientValidators(),
                        allowEmailCharacters: true,
                        events: {

                        },
                    })
                ],
            },
            {
                info: {
                    id: 'email5-title-row',
                     panelClass: 'custom-50p',
                },
                items: [
                    {
                        id: 'email-recipient-5-title',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        name: 'emailRecipient5Title',
                        label: 'LOCATION_CARD.RECIPIENT_5',
                        textClass: 'input-text',
                        panelClass: 'custom-33p width-30',
                    },
                    field.text(AdvancedFieldId.CheckInEmailRecipient5, 'recipient5', {
                        value: config?.emailrecipients && config.emailrecipients[4] ? config.emailrecipients[4].recipient : null,
                        panelClass: 'custom-33p padding-right-50',
                        validators: getEmailRecipientValidators(),
                        allowEmailCharacters: true,
                        events: {

                        },
                    })
                ],
            },
        ],
    };
};
